var map = {
	"./about/page.tsx": 6767,
	"./certificates/[id]/page.tsx": 4920,
	"./certificates/page.tsx": 1345,
	"./index/page.tsx": 4237,
	"./login/page.tsx": 7236,
	"./posts/[id]/page.tsx": 5406,
	"./posts/page.tsx": 5884,
	"./projects/[id]/page.tsx": 2581,
	"./projects/page.tsx": 8798,
	"./skills/page.tsx": 7309
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4605;